import {AxiosResponse} from 'axios';
//api
import {orgAPI, userAPI} from '@/core/api';
//types
import {
  IEventTodoList,
  IOrganizationEvent,
  IOrganizationEventRequest,
  IOrganizationSponsorCategoryResponse,
  IOrganizationSponsor,
  IOrganizationEventTodoList,
  IRaffleWinnerResponse,
} from '@/utils/types';
//enum
import {API_URL} from '../enums/api-url.enum';
import {EVENT_IMAGE} from '../enums';

class OrganizationEventService {
  static getSponsorCategories = async (organizationId: number): Promise<AxiosResponse<IOrganizationSponsorCategoryResponse[]>> =>
    orgAPI.get(`${API_URL.EVENT_SPONSOR_CATEGORIES}?organizationId=${organizationId}`);

  static createEvent = async (reqBody: IOrganizationEventRequest): Promise<AxiosResponse<number>> =>
    orgAPI.post(API_URL.EVENT, reqBody);

  static getEvent = async (id: string | number): Promise<AxiosResponse<IOrganizationEvent>> =>
    orgAPI.get(`${API_URL.EVENT}/${id}`);

  static getEvents = async (id: number): Promise<AxiosResponse<IOrganizationEvent[]>> =>
    orgAPI.get(`${API_URL.GET_EVENTS}/${id}`);

  static getEventTodoList = async (eventId: number, isDone: boolean): Promise<AxiosResponse<IEventTodoList[]>> =>
    orgAPI.get(API_URL.EVENT_TODO_LIST, {params: {eventId, isDone}});

  static updateEventType = async (eventId: number, isOnlineAuction: boolean): Promise<AxiosResponse> =>
    orgAPI.put(`${API_URL.EVENT}/${eventId}/type`, {isOnlineAuction});

  static updateEvent = async (
    id: number,
    reqBody: IOrganizationEventRequest
  ): Promise<AxiosResponse<IOrganizationEvent>> => orgAPI.put(`${API_URL.EVENT}/${id}`, reqBody);

  static presignedImage = async (type: EVENT_IMAGE): Promise<AxiosResponse> =>
    orgAPI.get(`${API_URL.PRESIGNED_EVENT_IMAGE}?type=${type}`);

  static addSponsorToEvent = async (
    eventId: number,
    reqBody: {name: string; categoryId: number; logo: string}
  ): Promise<AxiosResponse> => orgAPI.post(`${API_URL.EVENT}/${eventId}/sponsor`, reqBody);

  static getSponsorById = async (id: number): Promise<AxiosResponse<IOrganizationSponsor>> =>
    orgAPI.get(`${API_URL.EVENT_SPONSOR}/${id}`);

  static updateSponsor = async (
    id: number,
    reqBody: {name: string; categoryId: number; logo: string}
  ): Promise<AxiosResponse<IOrganizationSponsor>> => orgAPI.put(`${API_URL.EVENT_SPONSOR}/${id}`, reqBody);

  static deleteSponsor = async (id: number): Promise<AxiosResponse> => orgAPI.delete(`${API_URL.EVENT_SPONSOR}/${id}`);

  static createTodoItem = async (
    reqBody: Omit<IOrganizationEventTodoList, 'id'>
  ): Promise<AxiosResponse<IEventTodoList>> => {
    return orgAPI.post(`${API_URL.EVENT_TODO_ITEM}`, reqBody);
  };

  static updateTodoItem = async (reqBody: {id: number; isDone: boolean}): Promise<AxiosResponse> => {
    return orgAPI.put(`${API_URL.EVENT_TODO_ITEM}`, reqBody);
  };

  static getEventBySlug = async (slug: string): Promise<AxiosResponse<IOrganizationEvent>> =>
    userAPI.get(`${API_URL.EVENT_BY_SLUG}/${slug}`);

  static getRaffleWinner = async (eventId: number): Promise<AxiosResponse<IRaffleWinnerResponse>> =>
    orgAPI.post(`${API_URL.EVENT}/${eventId}/raffle/winner`);

  static createSponsorCategory = async (organizationId: number, name: string): Promise<AxiosResponse<IOrganizationSponsorCategoryResponse>> => {
    return orgAPI.post(`${API_URL.ADD_SPONSOR_CATEGORY}?organizationId=${organizationId}&name=${name}`);
  };
}

export {OrganizationEventService};
